<template>
  <div>
    <van-nav-bar
      title="订单"
      left-text="返回"

      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="onSubmit">
      <van-field v-model="id" type="digit" label="订单ID" />
      <van-field name="radio" label="状态">
        <template #input>
          <van-radio-group v-model="status" direction="horizontal">
           <van-radio name="1">等待调货</van-radio>
           <van-radio name="2">等待发货</van-radio>
           <van-radio name="3">发货完成</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" @click="getorders">搜索</van-button>
      </div>
    </van-form>


    <div style="overflow-y:scroll;height: 844px;">
      <van-cell-group inset style="margin-top:10px;" v-for="item in orders" :key="item.id" label-class="celllabel"  @click="todetail(item)">
        <van-cell :value="item.dis_status" :title="item.fabu_datetime"/>
        <van-cell :title=" '订单ID：'+item.id" :value="item.salername" />
        <van-cell :title="'客户：'+item.clientname" :value="'总价'+item.total_price"/>
      </van-cell-group>


    </div>


  </div>
</template>

<script>
  import * as Api from './api.js'
import { Toast } from 'vant';
  export default {
    name: 'RukuList',
    data () {
      return {
        value:'',
        orders:[],
        status:'1',
        id:''





      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
      this.getorders()
    },
    methods:{
      getorders(){
        let query = {
          limit:999,
          status:this.status,
          id:this.id,
          ordering:'-id'
        }
        console.log(query)
        Api.getorders(query).then(res=>{
          this.orders = res.data.data
        })

      },
      onClickLeft(){
        this.$router.push({path:'/'})
      },
      todetail(item){
        console.log(item.id)
        this.$router.push({path:'/shangwuviews/ordersdetail',query:{id:item.id}})

      }



    }
  }

</script>

<style>
  .celllabel{
    width:100%
  }
</style>



// WEBPACK FOOTER //
// src/views/shangwuviews/orders/index.vue